import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjEnter"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M14.2358 10.2661H1.7638C1.62235 10.2661 1.4867 10.2099 1.38668 10.1099C1.28666 10.0099 1.23047 9.87422 1.23047 9.73277C1.23047 9.59132 1.28666 9.45566 1.38668 9.35565C1.4867 9.25563 1.62235 9.19944 1.7638 9.19944H13.7025V3.00477C13.7025 2.86332 13.7587 2.72766 13.8587 2.62765C13.9587 2.52763 14.0944 2.47144 14.2358 2.47144C14.3773 2.47144 14.5129 2.52763 14.6129 2.62765C14.7129 2.72766 14.7691 2.86332 14.7691 3.00477V9.73277C14.7691 9.80281 14.7553 9.87216 14.7285 9.93687C14.7017 10.0016 14.6625 10.0604 14.6129 10.1099C14.5634 10.1594 14.5046 10.1987 14.4399 10.2255C14.3752 10.2523 14.3058 10.2661 14.2358 10.2661Z",
  fill: "#A5ACBE"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M5.02987 13.5287C4.95981 13.5287 4.89042 13.515 4.82568 13.4882C4.76093 13.4614 4.7021 13.4222 4.65253 13.3727L1.3872 10.106C1.28746 10.006 1.23145 9.87054 1.23145 9.72932C1.23145 9.58809 1.28746 9.45263 1.3872 9.35265L4.65253 6.08598C4.75261 5.98591 4.88834 5.92969 5.02987 5.92969C5.17139 5.92969 5.30712 5.98591 5.4072 6.08598C5.50727 6.18606 5.5635 6.32179 5.5635 6.46332C5.5635 6.60484 5.50727 6.74058 5.4072 6.84065L2.51787 9.73398L5.4072 12.618C5.48187 12.6926 5.53273 12.7876 5.55335 12.8912C5.57396 12.9947 5.5634 13.102 5.523 13.1995C5.4826 13.297 5.41417 13.3803 5.32639 13.4389C5.23861 13.4975 5.13541 13.5287 5.02987 13.5287Z",
  fill: "#A5ACBE"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var SJ_enter = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_enter as default };
